import { UserInfo } from "@/features/authentication/context/auth/auth.types";
import { AnalyticsBrowser } from "@segment/analytics-next";
import { SEGMENT_KEY } from "../constants/key";
import { ParsedTrackData, TrackData } from "../entities/track-data.types";

const analytics = AnalyticsBrowser.load({ writeKey: SEGMENT_KEY });

export const generateTrackData = <T>(
  data: TrackData<T>,
): ParsedTrackData<T> => {
  const parsedData = {
    product: "Backoffice",
    product_type: "Backoffice",
    origin: data.origin ?? "web",
    url_page: data.urlPage,
    user_id: data.userId,
    user_email: data.userEmail,
    category: data.category,
  } as ParsedTrackData;

  Object.assign(parsedData, {
    ...(data.value !== null &&
      JSON.stringify(data.value) !== "{}" && {
        value: JSON.stringify(data.value),
      }),
    ...(data.cityName && {
      filter_city_name:
        typeof data.cityName === "string" ? data.cityName : data.cityName[0],
    }),
    ...(data["neighborhood[]"] !== null && {
      filter_neighborhood:
        typeof data["neighborhood[]"] === "string"
          ? [data["neighborhood[]"]]
          : data["neighborhood[]"]?.join(","),
    }),
    ...(data.spaceId !== null && { filter_space: data.spaceId?.join(",") }),
    ...(data.private_office_ids &&
      data.private_office_ids.length > 0 && {
        filter_room_id: data.private_office_ids.join(","),
      }),
    ...(data.capacity &&
      data.capacity.length > 1 && {
        filter_capacity_min: data.capacity[0],
        filter_capacity_max: data.capacity[1],
      }),
    ...(data.capacity &&
      data.capacity.length === 1 && { filter_capacity_max: data.capacity[0] }),
    ...(data.creditPrice !== null && { filer_credit_price: data.creditPrice }),
    ...(data.status !== null &&
      data.status !== undefined && { status: data.status.toString() }),
    ...(data.proposalLongUrl !== null && {
      proposal_url: data.proposalLongUrl,
    }),
    ...(data.dealUrl !== null && { deal_url: data.dealUrl }),
  });

  return parsedData;
};

type SendTrackData = <T>(
  trackData: ParsedTrackData<T> & { eventName: string },
) => Promise<void>;

export const sendTrackData: SendTrackData = async ({
  eventName,
  ...trackData
}) => {
  if (!analytics) {
    console.error("Analytics instance is not defined.");
    return;
  }

  try {
    await analytics.track(eventName, trackData);
    console.log(`trackEventManager > segment new: ${eventName}`);
    console.table(trackData);
  } catch (error) {
    console.error(`Failed to send track data for event: ${eventName}`, error);
  }
};

export const sendUserIdentifyData = async (userInfo: UserInfo) => {
  if (analytics) {
    analytics.identify(`${userInfo.user?.id}`, {
      email: userInfo?.profile?.email,
      is_plg: userInfo?.user?.is_plg,
      league_id: userInfo?.league?.id,
      league_name: userInfo?.league?.name,
      plan_id: userInfo?.plan?.id,
      plan_name: userInfo?.plan?.name,
    });
  }
};
